import script from "./NewHome.vue?vue&type=script&setup=true&lang=js"
export * from "./NewHome.vue?vue&type=script&setup=true&lang=js"

import "./NewHome.vue?vue&type=style&index=0&id=b9aa1326&scoped=true&lang=css"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9aa1326"]])

export default __exports__